import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/key-features/Banner";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import FeaturesList from "../components/key-features/FeaturesList";
import Cta from "../components/key-features/Cta";
import Testimonials from "../components/key-features/Testimonials";

const KeyFeatures = () => {
  return (
    <Layout>
      <Banner />
      <IndustryLeaders />
      <FeaturesList />
      <Cta />
      <Testimonials />
    </Layout>
  );
};

export default KeyFeatures;

